import ClipBoard from "clipboard"
import React, { useEffect, useState } from "react"
import ReactGA from "react-ga"
import "./IconCell.css"

const IconCell = ({ name, icon }) => {
  const displayName = icon.display
  const fileName = icon.name

  const normalIcon = `/softies/icons/${icon.name}.svg`
  const altIcon = `/softies/pink-icons/${icon.name}.svg`
  const [shouldShowAltIcon, setShouldShowAltIcon] = useState(false)

  const copyButton = React.createRef()
  const [clipboard, setClipboard] = useState(null)

  const setupClipboard = copyButton => {
    if (clipboard === null) {
      fetch(normalIcon)
        .then(response => {
          return response.text()
        })
        .then(text => {
          var parser = new DOMParser()
          var xmlDoc = parser.parseFromString(text, "text/xml")
          var svg = xmlDoc.getElementsByTagName("svg")[0].outerHTML

          setClipboard(
            (() => {
              const clipboard = new ClipBoard(copyButton, {
                text: function(trigger) {
                  ReactGA.event({
                    category: "Softies",
                    action: "Copy SVG",
                    label: trigger.parentNode.dataset.name
                  })
                  return svg
                }
              })

              clipboard.on("success", e => {
                copyButton.innerHTML = "Copied!"
                setTimeout(() => {
                  copyButton.innerHTML = "Copy &lt;SVG&gt;"
                }, 1000)

                e.clearSelection()
              })

              return clipboard
            })()
          )
        })
        .then(() => (copyButton.innerHTML = "Copy &lt;SVG&gt;"))
    }
  }

  useEffect(() => () => (clipboard ? clipboard.destroy() : null), [clipboard])

  return (
    <li
      onMouseEnter={() => {
        setShouldShowAltIcon(true)
        setupClipboard(copyButton.current)
      }}
      onMouseLeave={() => setShouldShowAltIcon(false)}
    >
      <h2>{displayName}</h2>
      <img
        src={shouldShowAltIcon ? altIcon : normalIcon}
        alt={fileName + " icon"}
      />
      <a
        className="download"
        onClick={() => {
          ReactGA.event({
            category: "Softies",
            action: "Download SVG",
            label: name
          })
        }}
        href={"/softies/icons/" + fileName + ".svg"}
        download
      >
        Download
      </a>
      <button ref={copyButton} className="copy">
        Preapring&hellip;
      </button>
    </li>
  )
}

export default IconCell
